<template>
  <ul class="list-disc px-4 ml-4">
    <li>
      Saisonkennzeichen:
      <span :title="getSourceDisplayInformation(props.startPath)">
        {{ from }}
      </span>
      -
      <span :title="getSourceDisplayInformation(props.endPath)">{{ to }}</span>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { getMonthName, isDate } from '@/utils/dates/dates';
import { useInputMappingStore } from '@/features/InputMapping/store';

interface Props {
  startPath: string;
  endPath: string;
}

const props = defineProps<Props>();
const { getSourceDisplayInformation, getValue } = useInputMappingStore();

const getLabel = (val: Date | string) => {
  const dateVal = new Date(val);
  if (isDate(dateVal)) {
    return getMonthName(dateVal);
  }

  return val;
};

const from = computed(() => getLabel(getValue(props.startPath)));
const to = computed(() => getLabel(getValue(props.endPath)));
</script>
